import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full sm:w-6/12 text-center mx-auto justify-center p-2"
}
const _hoisted_2 = { class: "flex justify-center" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "text-2xl" }
const _hoisted_5 = {
  key: 0,
  class: "text-gray-700 text-sm"
}
const _hoisted_6 = { class: "text-center my-4 w-9/12 m-auto" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "text-gray-500 text-xs mt-1" }
const _hoisted_9 = { class: "w-9/12 m-auto" }
const _hoisted_10 = { class: "mx-auto" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "mx-auto" }, "マイページに戻る", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _component_ContinuouslyExchangeCards = _resolveComponent("ContinuouslyExchangeCards")!

  return (!!_ctx.lastExchangeResult.gift && _ctx.exchangeButtonLabel)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_BaseCard, { class: "p-4" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title), 1),
                (_ctx.subTitle)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.subTitle), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _ctx.lastExchangeResult.gift.image_url,
                class: "mx-auto"
              }, null, 8, _hoisted_7),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.lastExchangeResult.gift.name), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_BaseButton, {
                class: "w-full",
                buttonClass: "main",
                onClick: _ctx.handleGoGiftClick
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.exchangeButtonLabel), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_BaseButton, {
                class: "w-full mt-3",
                buttonClass: "outlined",
                onClick: _ctx.mypageLinkTo
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_ContinuouslyExchangeCards, { class: "mt-2" })
      ]))
    : _createCommentVNode("", true)
}